'use strict';

exports.enUS = require('./enUS');